module.exports = "/_next/static/images/ca90ff6a5dd35269cbfbfe390a661cd8-bubble-gum-woman-square@md-2x.jpg.webp";